<div class="table-view-container" *ngIf="table">
  <!-- Header -->
  <div class="table-header">
    <div class="header-left">
      <button mat-icon-button (click)="onBack()" class="back-button">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="table-info">
        <h2>{{ table.tableName }}</h2>
        <p *ngIf="table.tableDescription">{{ table.tableDescription }}</p>
      </div>
    </div>
    <div class="header-actions">
      <button mat-button (click)="onRefresh()" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
      <button mat-raised-button color="primary" (click)="onExport()">
        <mat-icon>download</mat-icon>
        Export
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <mat-spinner></mat-spinner>
    <p>Loading table data...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error" class="error-container">
    <mat-icon class="error-icon">error</mat-icon>
    <p>{{ error }}</p>
    <button mat-raised-button color="primary" (click)="onRefresh()">
      Try Again
    </button>
  </div>

  <!-- Table Data -->
  <div *ngIf="!loading && !error" class="table-content">
    <p-table
      #dt
      [value]="tableData"
      [scrollable]="true"
      scrollHeight="flex"
      styleClass="custom-table"
      [globalFilterFields]="tableHeaders">

      <ng-template pTemplate="caption">
        <div class="table-caption">
          <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="onGlobalFilter($event)" placeholder="Search all columns..." class="global-filter" />
          </span>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let header of tableHeaders" class="table-header-cell" [pSortableColumn]="header">
            <div class="header-content">
              {{ header }}
              <p-sortIcon [field]="header"></p-sortIcon>
            </div>
          </th>
        </tr>
        <tr>
          <th *ngFor="let header of tableHeaders" class="filter-cell">
            <input pInputText type="text" (input)="onColumnFilter($event, header)" placeholder="Filter..." class="column-filter" />
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row>
        <tr>
          <td *ngFor="let header of tableHeaders" class="table-cell">
            {{ row[header] }}
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="tableHeaders.length" class="empty-message">
            <div class="empty-content">
              <mat-icon>table_chart</mat-icon>
              <p>No data available</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- No Table Selected -->
  <div *ngIf="!table" class="no-table-selected">
    <mat-icon class="empty-icon">table_chart</mat-icon>
    <p>No table selected for viewing</p>
  </div>
</div>
